import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { LineItemRoutePathName } from '@/modules/to/lineitem/lineitem.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: 'entity/lineitems',
      name: LineItemRoutePathName,
      component: () =>
        import(/* webpackChunkName: "lineitem-list-page" */ './pages/LineItemListPage'),
    },
    {
      path: `entity/lineitems/:id`,
      name: 'edit-entity-line-item',
      component: () =>
        import(/* webpackChunkName: "line-item-details-page" */ './pages/LineItemDetailsPage'),
      props: true,
    },
  ],
  Module.LINEITEM
);
